import React from 'react'
import {AiOutlineCaretDown , AiFillShopping , AiFillCaretRight } from "react-icons/ai"
import {GiMedicines} from "react-icons/gi"
import ListMedicaments from '../allMedicaments/ListMedicaments'
import MedicamentsEnCours from '../allMedicaments/MedicamentsEnCours'
import MedicamentsLivres from '../allMedicaments/MedicamentsLivres'
import Cotisation from './Cotisation'
import Panier from './Panier'
export  const dashbordClient = [
    {
        title: 'Mes medicaments',
        cName : "clientMedicament",
        titleIcon: <AiFillCaretRight />,
        content: [{
            icon: <GiMedicines /> ,
            contentText : "Commander",
            path:"commander",
            destination:<ListMedicaments />
            },
            {
                icon: <AiFillShopping />,
                contentText : "Commande en cours",
                path:"commandeencours",
                destination: <MedicamentsEnCours />
            },
            {
                icon: <AiFillShopping />,
                contentText : "Commande valides",
                path:"commandelivre",
                destination: <MedicamentsLivres />
            },
            {
                icon: <AiFillShopping />,
                contentText : "Panier des commandes",
                path:"panier",
                destination: <Panier />
            }      
        ]
    },
    {
        title: 'Cotisation',
        cName : "clientMedicament",
        titleIcon: <AiFillCaretRight />,
        content: [{
            icon: <GiMedicines /> ,
            contentText : "Ajouter une facture",
            path:"cotisation",
            destination:<Cotisation />,
            } 
        ]
    }
]
